// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { usefulLifeRevisionSchema } from '@/asset/api/types';
import { UsefulLifeRevisionReason } from '@/constants/useful-life-revision';
import { serializeDateForAPI } from '@/utilities/date-time';
import { DateTime } from 'luxon';
import { z } from 'zod';

const createUsefulLifeRevisionResponseSchema = z
  .object({
    data: usefulLifeRevisionSchema,
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({ ...response, revision: data }));

export interface CreateUsefulLifeRevisionParameters {
  effectiveDate: DateTime;
  usefulLifeMonths: number;
  reason: UsefulLifeRevisionReason;
  notes: string | null;
}

export async function createUsefulLifeRevision(
  assetKey: string,
  parameters: CreateUsefulLifeRevisionParameters
) {
  const path = `/v1/asset/${assetKey}/useful-life-revision`;
  const response = await api.post(path, {
    ...parameters,
    effectiveDate: serializeDateForAPI(parameters.effectiveDate),
  });

  return parseResponse(createUsefulLifeRevisionResponseSchema, response.data, {
    schemaName: 'CreateAssetUsefulLifeRevision',
    endpoint: path,
  });
}
